module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-header"
  }, [_c('div', {
    staticClass: "search-headerBack",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-headerHome"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-searchBox"
  }, [_c('label', {
    attrs: {
      "for": "searchBox"
    }
  }, [_c('Icon', {
    staticClass: "searchIcon",
    attrs: {
      "type": "android-search",
      "size": "22",
      "color": "#007AFF"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchMsg),
      expression: "searchMsg",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "searchBox",
      "placeholder": "书名/作者/关键词"
    },
    domProps: {
      "value": (_vm.searchMsg)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchMsg = $event.target.value.trim()
      }, function($event) {
        _vm.getSearch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCloseIcon),
      expression: "showCloseIcon"
    }],
    staticClass: "closeIcon",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.clearSearchMsg()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close-outline",
      "size": "18"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [(_vm.showRecomSearch) ? _c('div', {
    staticClass: "recomSearch"
  }, [_c('ul', _vm._l((_vm.recomSearchArr), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.showSearchList) ? _c('div', {
    staticClass: "searchList"
  }, [_c('ul', [_vm._l((_vm.handleSearchListArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.showSearchData(item.title)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
  }), _vm._v(" "), (_vm.handleSearchListArr.length == 0) ? _c('li', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v("无搜索结果！")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showSearchResult) ? _c('div', {
    staticClass: "searchResult"
  }, [_c('ul', _vm._l((_vm.searchResultArr), function(item) {
    return _c('li', [_c('router-link', {
      staticClass: "searchResult-img",
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }))]) : _vm._e()]), _vm._v(" "), (_vm.searchHistoryList.length > 0) ? _c('div', {
    staticClass: "search-history"
  }, [_c('div', {
    staticClass: "search-historyHeader"
  }, [_c('span', {
    staticClass: "search-historyTitle"
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('span', {
    staticClass: "search-historyDelBtn",
    on: {
      "click": function($event) {
        _vm.clearHistory()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-a",
      "size": "30"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-historyContent"
  }, [_c('ul', _vm._l((_vm.searchHistoryList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.showSearchData(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('search-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-headerTitle"
  }, [_c('span', [_vm._v("搜索中心")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-cf8f61e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/index.vue
// module id = 197
// module chunks = 1